export const REPORT_DATA_NAMESPACE = 'reportData';